import script from "./_bullets.vue?vue&type=script&setup=true&lang=js"
export * from "./_bullets.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__